import { render, staticRenderFns } from "./Customization.vue?vue&type=template&id=b08b968c"
import script from "./Customization.vue?vue&type=script&lang=js"
export * from "./Customization.vue?vue&type=script&lang=js"
import style0 from "./Customization.vue?vue&type=style&index=0&id=b08b968c&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b08b968c')) {
      api.createRecord('b08b968c', component.options)
    } else {
      api.reload('b08b968c', component.options)
    }
    module.hot.accept("./Customization.vue?vue&type=template&id=b08b968c", function () {
      api.rerender('b08b968c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/settings/Customization.vue"
export default component.exports